var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAirplane2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "md-airplane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broker-Mode---Quote-Request",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-light/v3/-Bookings/Quote-Request/01-All-Request",
    transform: "translate(-961.000000, -1361.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(375.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Declined",
    transform: "translate(0.000000, 1062.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "De-Arr",
    transform: "translate(445.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(110.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md-airplane",
    transform: "translate(31.500000, 6.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,8.5 L12.5,7.25 L7.5,4 L7.5,0.475 C7.5,-0.078125 7.0375,-0.5 6.5,-0.5 C5.9625,-0.5 5.5,-0.078125 5.5,0.475 L5.5,4 L0.5,7.25 L0.5,8.5 L5.5,7 L5.5,10.55 L4,11.525 L4,12.5 L6.5,12 L9,12.5 L9,11.525 L7.5,10.55 L7.5,7 L12.5,8.5 Z",
    id: "Path",
    transform: "translate(6.500000, 6.000000) rotate(90.000000) translate(-6.500000, -6.000000) "
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirplane2);
export default __webpack_public_path__ + "static/media/icon-airplane-2.2f5dadcb.svg";
export { ForwardRef as ReactComponent };